import { render, staticRenderFns } from "./probationAssignment.vue?vue&type=template&id=42d815a8&scoped=true&"
import script from "./probationAssignment.vue?vue&type=script&lang=js&"
export * from "./probationAssignment.vue?vue&type=script&lang=js&"
import style0 from "./probationAssignment.vue?vue&type=style&index=0&id=42d815a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d815a8",
  null
  
)

export default component.exports